<ng-container *ngIf="startLoadingPerformers == true; else noLoadedPerformers">
    <ng-container
        *ngIf="
            noneToDisplay === false &&
                displayPeople &&
                (displayPeople.length || displayPeople.userId);
            else noDisplayedPerformers
        "
    >
        <ng-container *ngIf="type == 'multi'; else single">
            <ng-container
                *ngFor="
                    let member of displayPeople;
                    let i = index;
                    trackBy: trackPeople(index, member)
                "
            >
                <!-- member summary -->
                <tr
                    personRow
                    *ngIf="member?.displayForTeam === true"
                    [activeMetric]="activeMetric"
                    [activeMember]="activeMember"
                    [activecolumns]="activecolumns"
                    [activeView]="activeView"
                    [columns]="columns"
                    [member]="member"
                    [rowIndex]="i"
                    [rowExpanded]="rowExpanded"
                    (rowExpandedChange)="rowExpandedChange.emit($event)"
                    (openedWithNonKPIButton)="openNonKPI = $event"
                    (openedWithoutOpp)="openedWithoutOpp.emit($event)"
                ></tr>
                <!-- member details -->
                <tr
                    personRowDetail
                    #activeRowDetail
                    *ngIf="member?.active == true"
                    [member]="member"
                    [activeView]="activeView"
                    [activecolumns]="activecolumns"
                    [activeMetric]="activeMetric"
                    (triggerDone)="decideIfScroll(activeRowDetail)"
                    [openNonKPI]="openNonKPI"
                ></tr>
            </ng-container>
        </ng-container>
        <ng-template #single>
            <!-- member summary -->
            <tr
                personRow
                [activecolumns]="activecolumns"
                [activeMetric]="activeMetric"
                [activeMember]="activeMember"
                [activeView]="activeView"
                [member]="displayPeople"
                [columns]="columns"
                [rowIndex]="0"
                [rowExpanded]="rowExpanded"
                (rowExpandedChange)="rowExpandedChange.emit($event)"
                (openedWithNonKPIButton)="openNonKPI = $event"
                (openedWithoutOpp)="openedWithoutOpp.emit($event)"
            ></tr>

            <!-- member details -->
            <tr
                personRowDetail
                #activeRowDetail
                *ngIf="displayPeople.active === true"
                [member]="displayPeople"
                [activeView]="activeView"
                [activecolumns]="activecolumns"
                [activeMetric]="activeMetric"
                (triggerDone)="decideIfScroll(activeRowDetail)"
                [openNonKPI]="openNonKPI"
            ></tr>
        </ng-template>
    </ng-container>
</ng-container>
<ng-template #noLoadedPerformers>
    <tr>
        <td [colSpan]="activecolumns">
            <cmps-wait-status class="p-1"></cmps-wait-status>
            <div class="pb-3 text-center">
                {{ i18n._7355_LOADING_PERFORMERS_ | translate }}...
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #noDisplayedPerformers>
    <tr>
        <td [colSpan]="activecolumns">
            <div class="p-3 text-center">
                {{ i18n._711_NO_DATA_AVAILABLE | translate }}.
            </div>
        </td>
    </tr>
</ng-template>
